<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body" style="height: 300px;">

              <el-form :model="addForm" :rules="rules" ref="addForm">

                <el-row>
                    <el-col :span="12" class="item">
                        <el-form-item label="选择用户" required prop="userName">
                            <el-input v-model="addForm.userName" disabled placeholder="请选择提问用户">
                                <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="咨询状态" required prop="status">
                            <el-select v-model="addForm.status" placeholder="请选择咨询状态" style="width:100%">
                                <el-option
                                        v-for="item in status2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="item">
                        <el-form-item label="咨询问题" required prop="question">
                            <el-input type="textarea" v-model="addForm.question" :rows="4" placeholder="请输入用户问题"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="item">
                        <el-form-item label="问题答复" prop="reply">
                            <el-input type="textarea" v-model="addForm.reply" :rows="4" placeholder="请输入问题答复"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

              </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>

        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import GetElderly from "@/views/Elderly/Comm/ElderlyGov";

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                showModalGetElderly: false,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    userCode:'',
                    userName:'',
                    status:null,
                    question:'',
                  reply:'',
                },
                status2: [{
                    value: 1,
                    label: '未答复'
                }, {
                    value: 2,
                    label: '已答复'
                }],
                rules:{
                    status:[
                        { required: true, message: '请选择咨询状态', trigger: 'blur' },
                    ],
                    userName:[
                        { required: true, message: '请选择用户', trigger: 'blur' }
                    ],
                    question:[
                        { required: true, message: '请输入咨询问题', trigger: 'blur' },
                    ],
                }


            }
        },
        components: {GetElderly},
        methods: {
            init(){
                this.$refs.addForm.resetFields();
            },
            closeSelf() {
                this.$emit("closeAdd");
            },

            getElderly(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            setElderly(row){
                this.addForm.userCode=row.userCode;
                this.addForm.userName = row.name;
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ConsultRecord/StaffAdd",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 300px;
              overflow-y: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
